var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useEffect, useState } from "react";
import { BreadCrumbSteps, BreadCrumbStepsVariant } from "@sequentech/ui-essentials";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useTranslation } from "react-i18next";
import { TallyStyles } from "@/components/styles/TallyStyles";
import { useGetOne, useNotify } from "react-admin";
import { WizardStyles } from "@/components/styles/WizardStyles";
import { EditTallySheet } from "./EditTallySheet";
import { ShowTallySheet } from "./ShowTallySheet";
import { useMutation } from "@apollo/client";
import { CREATE_NEW_TALLY_SHEET } from "@/queries/createNewTallySheet";
import { IPermissions } from "@/types/keycloak";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
export var WizardSteps = {
    List: -1,
    Start: 1,
    Edit: 2,
    Confirm: 3,
    View: 4,
};
export var TallySheetWizard = function (props) {
    var action = props.action, election = props.election, tallySheetId = props.tallySheetId, doAction = props.doAction;
    var submitRef = React.useRef(null);
    var notify = useNotify();
    var t = useTranslation().t;
    var _a = useState(WizardSteps.Edit), page = _a[0], setPage = _a[1];
    var _b = useState(), areaId = _b[0], setAreaId = _b[1];
    var _c = useState(), createdTallySheet = _c[0], setCreatedTallySheet = _c[1];
    var _d = useState(), editedTallySheet = _d[0], setEditedTallySheet = _d[1];
    var _e = useState(false), isButtonDisabled = _e[0], setIsButtonDisabled = _e[1];
    var _f = useState(), choosenContest = _f[0], setChoosenContest = _f[1];
    var tallySheet = useGetOne("sequent_backend_tally_sheet", { id: tallySheetId }, { enabled: !!tallySheetId }).data;
    var contest = useGetOne("sequent_backend_contest", { id: tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.contest_id }, { enabled: !!tallySheet }).data;
    var CreateNewTallySheet = useMutation(CREATE_NEW_TALLY_SHEET, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.TALLY_SHEET_CREATE,
            },
        },
    })[0];
    useEffect(function () {
        if (action) {
            setPage(action);
        }
    }, [action]);
    useEffect(function () {
        if (contest) {
            setChoosenContest(contest);
        }
    }, [contest]);
    var insertTallySheetAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var tallySheetString, tallySheetData, errors, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    tallySheetString = localStorage.getItem("tallySheetData");
                    if (!tallySheetString) {
                        return [2 /*return*/];
                    }
                    tallySheetData = JSON.parse(tallySheetString);
                    return [4 /*yield*/, CreateNewTallySheet({
                            variables: {
                                electionEventId: tallySheetData.election_event_id,
                                channel: tallySheetData.channel,
                                content: tallySheetData.content,
                                contestId: tallySheetData.contest_id,
                                areaId: tallySheetData.area_id,
                            },
                        })];
                case 1:
                    errors = (_a.sent()).errors;
                    if (errors) {
                        notify(t("tallysheet.createTallyError"), { type: "error" });
                        console.log("Error creating tally sheet: ".concat(errors));
                    }
                    else {
                        notify(t("tallysheet.createTallySuccess"), { type: "success" });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    notify(t("tallysheet.createTallyError"), { type: "error" });
                    console.log("Error creating tally sheet: ".concat(error_1));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(page === WizardSteps.Start || page === WizardSteps.Edit)) return [3 /*break*/, 1];
                    (_a = submitRef.current) === null || _a === void 0 ? void 0 : _a.click();
                    // needs to wait for the click handler to submit the data
                    setTimeout(function () {
                        var tallySheet = localStorage.getItem("tallySheetData");
                        if (tallySheet) {
                            doAction(WizardSteps.Confirm);
                        }
                        else {
                            notify(t("tallysheet.allFieldsRequired"), { type: "error" });
                        }
                    }, 400);
                    return [3 /*break*/, 3];
                case 1:
                    if (!(page === WizardSteps.Confirm)) return [3 /*break*/, 3];
                    return [4 /*yield*/, insertTallySheetAction()];
                case 2:
                    _b.sent();
                    doAction(WizardSteps.List);
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleBack = function () {
        var tallySheet = localStorage.getItem("tallySheetData");
        var tallySheetTemp = JSON.parse(tallySheet || "{}");
        if (page === WizardSteps.Start) {
            doAction(WizardSteps.List);
        }
        else if (page === WizardSteps.Edit) {
            doAction(WizardSteps.List);
        }
        else if (page === WizardSteps.Confirm) {
            if (tallySheetId && tallySheetTemp && tallySheetTemp.id) {
                doAction(WizardSteps.List);
            }
            else {
                doAction(WizardSteps.Edit);
            }
        }
        else if (page === WizardSteps.View) {
            doAction(WizardSteps.List);
        }
    };
    return (_jsx(_Fragment, { children: _jsxs(WizardStyles.WizardWrapper, { children: [_jsx(TallyStyles.StyledHeader, { children: _jsx(BreadCrumbSteps, { labels: [
                            "tallysheet.breadcrumbSteps.edit",
                            page === WizardSteps.View
                                ? "tallysheet.breadcrumbSteps.view"
                                : "tallysheet.breadcrumbSteps.confirm",
                        ], selected: page, variant: BreadCrumbStepsVariant.Circle, colorPreviousSteps: true }) }), page === WizardSteps.Start && (_jsx(_Fragment, { children: _jsx(EditTallySheet, { election: election, choosenContest: choosenContest, setChoosenContest: setChoosenContest, doSelectArea: function (id) { return setAreaId(id); }, doCreatedTalySheet: function (tallySheet) {
                            setCreatedTallySheet(tallySheet);
                        }, submitRef: submitRef, setIsButtonDisabled: setIsButtonDisabled }) })), page === WizardSteps.Edit && (choosenContest || tallySheet) && (_jsx(_Fragment, { children: _jsx(EditTallySheet // TODO: EditTallySheet will keep the business logic for entering the results and calculations. But the area/contest/channel selection should be done on a separate component/step of the wizard
                    , { tallySheet: tallySheet, election: election, choosenContest: choosenContest, setChoosenContest: setChoosenContest, doCreatedTalySheet: function (tallySheet) {
                            setCreatedTallySheet(tallySheet);
                        }, submitRef: submitRef, setIsButtonDisabled: setIsButtonDisabled }) })), page === WizardSteps.Confirm && choosenContest && (_jsx(_Fragment, { children: _jsx(ShowTallySheet, { tallySheet: createdTallySheet || tallySheet, contest: choosenContest, doEditedTalySheet: function (tallySheet) {
                            return setEditedTallySheet(tallySheet);
                        }, submitRef: submitRef }) })), page === WizardSteps.View && choosenContest && (_jsx(_Fragment, { children: _jsx(ShowTallySheet, { tallySheet: tallySheet, contest: choosenContest, doEditedTalySheet: function (tallySheet) {
                            return setEditedTallySheet(tallySheet);
                        }, submitRef: submitRef }) })), _jsxs(WizardStyles.Toolbar, { children: [_jsxs(WizardStyles.BackButton, { color: "info", onClick: handleBack, className: "tsw-back-button", children: [_jsx(ArrowBackIosIcon, {}), t("common.label.back")] }), _jsxs(WizardStyles.NextButton, { color: "primary", disabled: isButtonDisabled, onClick: handleNext, className: "tsw-next-button", children: [page === WizardSteps.Edit
                                    ? t("tallysheet.common.confirm")
                                    : page === WizardSteps.Confirm
                                        ? t("tallysheet.common.save")
                                        : t("tallysheet.common.next"), _jsx(ChevronRightIcon, {})] })] })] }) }));
};
